import { Component } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social-linkedin',
    templateUrl: './freeway-layout-footer-social-linkedin.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialLinkedinComponent {}
